import React, { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import KOSearchInput from "../../components/KOSearchInput";
import KOSelectBox from "../../components/KOSelectBox";
import NBAKOPlayerCard from "../../components/NBA/KOPlayerCard";
import NBAPlayerStandings from "../../components/NBA/PlayerStandings";
import useSiteState from '../../appState/siteState/useSiteState';
import { store } from '../../appState/store';
import Paginate from "../../components/Paginate";
import * as contestService from "../../services/contestService";

const NBAPlayerPositionList = props => {

    const [addedPositions, setAddedPositions] = useState([])
    const [enablePlusIcon, setEnablePlusIcon] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [sortByvalue, setsortByvalue] = useState('name');
    const [showLoader, setshowLoader] = useState(false);
    const [playerListPosition, setplayerListPosition] = useState([]);
    const [playerPageNumber, SetplayerPageNumber] = useState(1);
    const [searchedData, setsearchedData] = useState(null);

    const filterState = props.value;
    const exampleArray = props.exampleArray;
    const siteState = useSiteState();
    let PlayerCardPlacingId = props.SelectedPlayerCardIndex;
    
    const [PaginationData, setPaginationData] = useState({
        perPage: 0,
        totalPages: 0,
        total: 0,
        currentPage:  0
    });

    useEffect(() =>{    
        if (props.SelectedPlayerCardIndex >= 0 && props.selectedPlayers && selectedIndex == -1) {
            let positions = props.selectedPlayers.map((row) => {
                return row.player_card_id;
            });
        
            if (positions.indexOf(props.SelectedPlayerCardIndex) > -1)
                setEnablePlusIcon(false)
            else{
                setSelectedIndex(positions.indexOf(props.SelectedPlayerCardIndex))
                setEnablePlusIcon(true)
            }
                
        }
    }, [props.selectedPlayers,props.loadPlayersByPositionTimer ]);


    useEffect(() =>{   
        if(props.SelectedPlayerCardIndex >= 0) {
            searchPlayerByPosition()
        }
    }, [props.SelectedPlayerCardIndex, props.loadPlayersByPositionTimer]);


    const siteData = store.getState().site
    const current_season_week = props.current_season_week;

    let playerPosition = props.PlayerPosition;
    let palyerPositionClass = 'quarterback';
    let setPlayerPosition;
    if (playerPosition === "C") {
        setPlayerPosition = "CENTER"
        palyerPositionClass = 'quarterback';
    } else if (playerPosition === "F") {
        setPlayerPosition = "FORWARD"
        palyerPositionClass = 'runningback';
    } else if (playerPosition === "G") {
        setPlayerPosition = "GUARD"
        palyerPositionClass = 'widereceiver';
    } else if (playerPosition === "FC") {
        setPlayerPosition = "FORWARD/CENTER"
        palyerPositionClass = 'tightend';
    } else if (playerPosition === "GF") {
        setPlayerPosition = "GUARD/FORWARD"
        palyerPositionClass = 'flexplayer';
    }


    const resetSearchBox = (values) => {
        filterState.SearchData = '';
    }

    const searchPlayerByPosition = () => {
        setsearchedData("");
        SetplayerPageNumber(1);
        fetchPlayersByPosition(props.SelectedPlayerCardIndex, 1, '', sortByvalue)
    }

    const callNextPosition = (position) => {
        props.callNextPositionOnSetup(position)
    }

    const updateSelectedCardIndex= (index, CardPosition) => {
        props.updateSelectedCardIndex(index, CardPosition)
    }
    const getPlayers = (playerList) => {
        if (playerList && playerList.length > 0) {
            return playerList.map((item, index) =>
                <Col md={4} key={item.player_id}>

                    <NBAKOPlayerCard
                        enablePlusIcon={enablePlusIcon}
                        callNextPosition={callNextPosition}
                        resetSearchBox={resetSearchBox}
                        className={item.className ? item.className : palyerPositionClass}
                        figure={item.player_img_url ? item.player_img_url : item.team_logo_url}
                        playername={item.player_full_name ? item.player_full_name : item.team_name}
                        playernumber={item.player_number ? item.player_number : item.team_id}
                        team={item.team_key ? item.team_key : item.team_key}
                        position={item.player_position ? item.player_position : "C"}
                        lineupno={props.lineUpNumber ? props.lineUpNumber : "1"}
                        lineupwk={props.lineUpWeek ? props.lineUpWeek : "1"}
                        playerId={item.player_id ? item.player_id : item.team_id}
                        teamId={item.team_id ? item.team_id : item.team_id}
                        uniqueId={item.player_id ? item.player_id : item.team_id}
                        positionPlaceId={PlayerCardPlacingId}
                        current_season_week={current_season_week}
                        is_added={item.is_added ? item.is_added : 0} //added in another week
                        isAlreadyPlayedInweek={item.played_in_week ? item.played_in_week : 0}
                        current_week={item.current_week ? item.current_week : 0}
                        is_player_locked={item.is_player_locked ? item.is_player_locked : 0}
                        is_team_locked={item.is_team_locked ? item.is_team_locked : 0}
                        is_player_injured={item.is_player_injured ? item.is_player_injured : 0}
                        player_season_score={item.player_season_score ? item.player_season_score : item.player_season_score}
                        is_player_news_avail={item.is_player_news_avail ? item.is_player_news_avail : 0}
                        byeweek={item.byeweek ? item.byeweek : 0}
                        addPlayersToLineup = {addPlayersToLineup}
                        lineUpPlayers ={props.lineUpPlayers}
                        removePlayersFromLineup = {props.removePlayersFromLineup}
                        team_id={item.team_id ? item.team_id : item.team_id}
                        removedLineupPlayers ={props.removedLineupPlayers}
                        lineUpPlayersScores = {props.lineUpPlayersScores}
                        playerprojectionscore={item.playerprojectionscore ? item.playerprojectionscore : 0}
                        playerweeklyscore={item.playerweeklyscore ? item.playerweeklyscore : 0}
                        teamprojectionscore={item.teamprojectionscore ? item.teamprojectionscore : 0}
                        homeTeam={item.home_team}
                        awayTeam={item.away_team}
                        scheduleDate={item.schedule_date}
                        sortByvalue = {sortByvalue}
                        updateSelectedCardIndex = {updateSelectedCardIndex}
                    />
                </Col>
            );

        }
        else {
            return <></>;
        }
    };

    


    const searchPlayers = (e) => {
        setsearchedData(e.target.value);
        SetplayerPageNumber(1);
        fetchPlayersByPosition(props.SelectedPlayerCardIndex, 1, e.target.value, sortByvalue)
    }

    const PageNumberChange = (page) => {
        SetplayerPageNumber(page);
        fetchPlayersByPosition(props.SelectedPlayerCardIndex, page, searchedData, sortByvalue)
    }

    const ytdsortOptions = [
        { value: 'name', label: 'Player Name' },
        { value: 'projectionpoint', label: 'Projected Points' },
        { value: 'ytdpoint', label: 'YTD Points' },
        { value: 'weeklypoint', label: 'Last Week Points' },
    ];

    const sortPlayers = (e) => {
        setsortByvalue(e.target.value);
        fetchPlayersByPosition(props.SelectedPlayerCardIndex, playerPageNumber, searchedData, e.target.value)
    }

    const addPlayersToLineup = (playerData) => {
        props.addPlayersToLineup(playerData)
        setshowLoader(false)
    }

    const fetchPlayersByPosition = async (player_card_id, pageNumber, playerSearch, sortingData) => {
        const payLoad = {
           "player_position":  props.PlayerPosition,
           "search_key":playerSearch,
           "player_card_id": player_card_id,
           "page": pageNumber,
           "week": props.lineUpWeek,
           "si_contest_id": props.constest_id,
           "isUserGame": false,
           "lineup_number": props.lineUpNumber,
           "sortBy": sortingData
       }
       setplayerListPosition([])
       setshowLoader(true)
       let playerListData = await contestService.getNBAPlayerList(payLoad);
       setshowLoader(false)
       
       if(playerListData?.success && playerListData?.errorCode == 200 && playerListData?.data?.playersData?.length) {
            setplayerListPosition(playerListData?.data?.playersData);
            setPaginationData({
                perPage: playerListData?.data?.perPage,
                totalPages: playerListData?.data?.totalPages,
                total: playerListData?.data?.total,
                currentPage:  playerListData?.data?.currentPage,
            })
       } else {
        setplayerListPosition([])
       }
   }
    return (
        <>
            <div className="player-list-container">
                <div className="position-title">
                    <h4>{setPlayerPosition}</h4>
                    <div className="input-field">
                    <KOSelectBox
                        id="sortoptiontype"
                        name="sortoptiontype"
                        label="Sort"
                        type="text"
                        options={ytdsortOptions}
                        onChange={(e) => { sortPlayers(e); }}
                        value={sortByvalue}
                    />
                        <KOSearchInput
                            id="searchfield"
                            placeholder="Search"
                            name="search"
                            type="text"
                            value={searchedData}
                            onChange={(e) => { searchPlayers(e); }}
                        />
                    </div>
                </div>
                <div className="row">

                    {
                        getPlayers(playerListPosition)
                    }
                    {showLoader && <div className="col-md-12"><div className="playercard" ><div className="loader-wrap"><div className="loader"></div></div></div></div>}
                    {!playerListPosition?.length && !showLoader && <div className="col-md-12"><div className="playercard"><span style={{ color: "red" }}>No records to display.</span></div></div>}
                    {( playerListPosition?.length && PaginationData) ? <Paginate paginationData={PaginationData} pageRows={playerListPosition?.length} onClick={PageNumberChange} /> : ""}
                </div>
            </div>
            <NBAPlayerStandings />

        </>

    );
}

export default (NBAPlayerPositionList);
